/* Mobile sources load only in their responsive slot. Both slots share playback controls. */
if (!customElements.get('campaign-mobile-video')) {
  customElements.define('campaign-mobile-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.video.muted = true;
      this.video.playsInline = true;
      this.userPaused = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.sync = () => {
        const playing = !this.video.paused && !this.video.ended;
        this.dataset.playing = String(playing);
        this.button.setAttribute('aria-label', playing ? 'Pause campaign video' : 'Play campaign video');
      };
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.video.paused) this.video.play().catch(() => this.sync());
        else this.video.pause();
      }, options);
      this.video.addEventListener('click', () => {
        if (!this.video.paused) {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      ['play', 'pause', 'ended', 'error'].forEach(event => this.video.addEventListener(event, this.sync, options));
      this.media = window.matchMedia('(max-width: 989px)');
      this.update = () => {
        const mobile = this.classList.contains('campaign__video-media--mobile');
        const hasMobile = this.closest('.campaign--video').dataset.mobileVideo === 'true';
        const active = (mobile && this.media.matches) || (!mobile && (!hasMobile || !this.media.matches));
        this.video.autoplay = active && !this.motion.matches && !this.userPaused;
        if (active) {
          if (this.video.dataset.src && !this.video.hasAttribute('src')) {
            this.video.src = this.video.dataset.src;
            this.video.load();
          }
          if (this.motion.matches) this.video.pause();
          else if (!this.userPaused) this.video.play().catch(() => this.sync());
        } else if (this.video.dataset.src) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
        } else if (hasMobile && this.media.matches) {
          this.video.pause();
        }
      };
      this.media.addEventListener('change', this.update);
      this.motion.addEventListener('change', this.update);
      this.update();
      this.sync();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.media?.removeEventListener('change', this.update);
      this.motion?.removeEventListener('change', this.update);
      this.video?.pause();
    }
  });
}
